import { computed, Directive, effect, ElementRef, HostListener, inject, input } from '@angular/core';
import { PanButtonComponent } from '../pan-button/pan-button.component';
import { PanRadioGroupDirective } from './pan-radio-group.directive';

@Directive({
  selector: '[panRadio]',
  standalone: false,
})
export class PanRadioDirective {
  private parent = inject(PanRadioGroupDirective);
  private host = inject(PanButtonComponent);
  private hostElement = inject<ElementRef<HTMLElement>>(ElementRef);

  public panRadio = input<string | number | boolean | undefined>();

  private isActive = computed(() => this.parent.panRadioGroup() === this.panRadio());

  constructor() {
    effect(() => {
      const isActive = this.isActive();
      this.host.overrideFill.set(isActive ? 'filled' : 'outline');
      this.host.overrideRole.set('radio');
      this.host.overrideAriaChecked.set(String(isActive));
      this.host.overrideAriaPressed.set(null);
    });
  }

  @HostListener('click') onClick() {
    this.parent.panRadioGroup.set(this.panRadio());
  }

  @HostListener('keydown', ['$event'])
  public onKeydown(event: KeyboardEvent) {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowDown' && event.key !== 'ArrowLeft' && event.key !== 'ArrowUp') {
      return;
    }

    const groupElement = this.hostElement.nativeElement.closest('[panRadioGroup]');
    if (!groupElement) return;

    const options = Array.from(groupElement.querySelectorAll('app-pan-button[panRadio], [panButton][panRadio]')) as HTMLElement[];
    if (options.length < 2) return;

    const currentIndex = options.indexOf(this.hostElement.nativeElement);
    if (currentIndex < 0) return;

    event.preventDefault();
    const isForward = event.key === 'ArrowRight' || event.key === 'ArrowDown';
    const nextIndex = isForward ? (currentIndex + 1) % options.length : (currentIndex - 1 + options.length) % options.length;
    const nextHost = options[nextIndex];
    const nextButton = nextHost.querySelector('button') as HTMLButtonElement | null;

    if (nextButton?.disabled) {
      return;
    }

    nextButton?.focus();
    nextButton?.click();
  }
}
